<template>
  <b-modal id="modal-signup" size="size-signup" hide-footer hide-header no-close-on-backdrop no-close-on-esc centered
           :modal-class="['modal-mobile-fullscreen modal-sign-up', hasPhotos ? 'modal-sign-up-with-photos' : '']">
    <PoweredBy v-if="showPoweredBy" class="mb-4" />
    <div class="d-block text-center mt-1 mt-lg-3 mb-3 logo">
      <img :src="getAppLogo" class="img-fluid" alt="Logo">
    </div>
    <div class="d-block text-center">
      <h5 v-if="getAppConfigReady && loginSubtitle" v-html="loginSubtitle" class="mb-3 intro-pre-title"></h5>
      <h1 class="modal-title pb-2">
        {{ eventName ? eventName : $t('pages.preview.signup_modal_title') }}
      </h1>


      <template v-if="socialLoginOnTop">
        <SocialLogin :title="$t('forms.login_form.social_login_title_top')" />
          <h4 class="modal-subtitle-sign pb-4"> {{$t('forms.login_form.social_login_title_or')}} <span class="text-lowercase">{{ $t('pages.signup.headline_txt') }} <router-link :to="{ name: 'login' }" exact class="text-primary text-capitalize">{{ $t('forms.signup_form.btn_login') }}</router-link></span></h4>
        </template>
        <template v-else>
          <h4 class="modal-subtitle-sign pb-4">
          <span>{{ $t('pages.signup.headline_txt') }}</span>
        <span><router-link :to="{ name: 'login' }" exact
                           class="p-2 text-primary link-login">{{ $t('forms.signup_form.btn_login') }}</router-link></span>
      </h4>
          </template>


    </div>
    <div class="d-block">
      <SignupForm/>
    </div>
  </b-modal>
</template>

<script>
import SignupForm from '@/components/SignupForm'
import {mapGetters} from "vuex";
import SocialLogin from "@/components/SocialLogin.vue";
import PoweredBy from "@/components/PoweredBy.vue";
import {bottomPoweredByUrls} from "@/consts";

export default {
  props: {
   eventName: {
     type: String,
     required: false
   },
    hasPhotos: {
      type: Boolean,
      required: false
    }

  },
  components: {
    PoweredBy,
    SocialLogin,
    SignupForm
  },
  computed: {
    ...mapGetters(['thirdLevelDomain', 'isPicaThirdLevelDomain']),
    ...mapGetters('appConfig', ['getAppConfigReady', 'loginSubtitle', 'getAppLogo', 'getHidePoweredByLogo']),
        socialLoginOnTop() {
      return ['photos'].includes(this.thirdLevelDomain)
    },

     showPoweredBy() {
      return this.getAppConfigReady && !this.getHidePoweredByLogo && !this.isPicaThirdLevelDomain
        && !(this.thirdLevelDomain in bottomPoweredByUrls)
    }
  }
}
</script>
